import {navWidth, navWidthMini} from "../../../../@signals";
import {dsColorNew} from "@palette";

export const MaximalLayoutNavToggleButtonStyles = (theme, isMini) => ({
    p: 0,
    top: 84,
    width: "20px",
    height: "44px",
    borderRadius: '0 6px 6px 0',
    position: 'fixed',
    left: (isMini ? navWidthMini.value: navWidth.value),
    zIndex: theme.zIndex.appBar + 110,
    backgroundColor: '#fff',
    border: `1px solid ${dsColorNew.grayBorder}`,
    borderLeft: 'none',
    color: '#9CA3AF',
    boxShadow: '2px 0 6px rgba(0,0,0,0.06)',
    '&:hover': {
        backgroundColor: '#F3F4F6',
        color: dsColorNew.appBlue,
    }
})